import AppStore from '../../stores/AppStore'
import type { ComposerProfile } from '../../stores/types'

export const getCurrentProfile = (): ComposerProfile | undefined => {
  const enabledComposer = AppStore.getExpandedComposerId()
  if (enabledComposer === 'omni') return

  const selectedProfilesFromStore = AppStore.getSelectedProfiles()
  const profilesForService = AppStore.getProfilesForService(enabledComposer)
  const selectedProfilesForService = selectedProfilesFromStore.filter(
    (profile) => profilesForService.map((p) => p.id).includes(profile.id),
  )
  if (Array.isArray(selectedProfilesForService))
    return selectedProfilesForService[0]
}
